import { MobileAppBuildStatus } from "src/utils/enums"
import { IosBuild } from "../../entities/iosBuild"
import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
	update: {
		buildNo?: number
		version?: string
		publishDate?: number
		status?: MobileAppBuildStatus
	}
}

export async function iosBuildUpdateApi(payload: RequestDataShape, token: string) {
	const endpoint = "/ios/build/update/v1"
	const requester = new ApiRequester<RequestDataShape, IosBuild>(endpoint)
	const response = await requester.sendRequest(payload, token)
	return response
}
